import { useState } from "react";
import Modal from "react-modal";
import Modal_true from "../Modal/Modal_true";
import { CheckTheArray } from "../../Functions/functions";
import Modal_false from "../Modal/modal_false";
import Modal_image from "../Modal/Modal_image";

export default function Answer(props) {
  const { extraStep } = props;
  const { finalImage } = props;
  const { finalImageAlt } = props;
  const { textCorrectAnswer } = props;
  const [modalIsOpen, setIsOpen] = useState(false);
  const [CorrectAnswer, SetCorrectAnswer] = useState(false);
  const [showExtraStep, setShowExtraStep] = useState(false);

  function openModal() {
    setIsOpen(true);
    const isCorrect = CheckTheArray(props.mycheck, props.defaultcheck);
    SetCorrectAnswer(isCorrect);
    if (isCorrect && extraStep) {
      setShowExtraStep(true);
    } else {
      setShowExtraStep(false);
    }
  }

  function closeModal() {
    setIsOpen(false);
    setShowExtraStep(false);
  }

  function handleButtonClick() {
    let radios = document.querySelectorAll('.radio-style');
    radios.forEach(radio => {
      radio.checked = false;
    });
  }

  function True() {
    if (showExtraStep) {
      return (
        <Modal_image
          Allcheck={props.mycheck}
          setChecked={props.setChecked}
          modalIsOpen={modalIsOpen}
          setIsOpen={setIsOpen}
          scount={props.scount}
          mycount={props.mycount}
          finalImage={finalImage}
          finalImageAlt={finalImageAlt}
          textCorrectAnswer={textCorrectAnswer}
        />
      );
    } else {
      return (
        <Modal_true
          Allcheck={props.mycheck}
          setChecked={props.setChecked}
          modalIsOpen={modalIsOpen}
          setIsOpen={setIsOpen}
          scount={props.scount}
          mycount={props.mycount}
        />
      );
    }
  }

  const gameLang = document.documentElement.lang || process.env.REACT_APP_LANG_TYPE;

  if (gameLang === "en") {
    return (
      <div className="submit-style">
        <input
          type="submit"
          value="Submit"
          className="submit-input"
          onClick={() => {
            openModal();
            handleButtonClick();
          }}
        />
        <Modal
          isOpen={modalIsOpen}
          ariaHideApp={true}
          contentLabel="Correct Answer Modal"
          shouldCloseOnOverlayClick={false}
          portalClassName="modal_correct_answer"
        >
          {CorrectAnswer ? (
            True()
          ) : (
            <Modal_false
              Allcheck={props.mycheck}
              setChecked={props.setChecked}
              modalIsOpen={modalIsOpen}
              setIsOpen={setIsOpen}
            />
          )}
        </Modal>
      </div>
    );
  } else {
    return (
      <div className="submit-style">
        <input
          className="submit-input"
          type="submit"
          value="Απάντηση"
          onClick={() => {
            openModal();
            handleButtonClick();
          }}
        />
        <Modal
          isOpen={modalIsOpen}
          ariaHideApp={true}
          contentLabel="Correct Answer Modal"
          shouldCloseOnOverlayClick={false}
          portalClassName="modal_correct_answer"
        >
          {CorrectAnswer ? (
            True()
          ) : (
            <Modal_false
              Allcheck={props.mycheck}
              setChecked={props.setChecked}
              modalIsOpen={modalIsOpen}
              setIsOpen={setIsOpen}
            />
          )}
        </Modal>
      </div>
    );    
  }
}